export default __webpack_public_path__ + "static/Rini Hayati Amril-b912ad1651ff39488572df1929b99ba7.webp";